import Navbar from '../components/navbar';
import hero from '../assets/images/phone/3-phone-half.png';

import FeaturesTwo from '../components/features-two';
import AboutOne from '../components/about-one';
import AboutTwo from '../components/about-two';
import Screenshot from '../components/screenshot';
import Faq from '../components/faq';
import Download from '../components/download';
import Client from '../components/client';
import Contact from '../components/contact';
import Partner from '../components/partner';
import Footer from '../components/footer';

import { useTranslation } from 'react-i18next';

export default function IndexTwo() {
  const { t } = useTranslation();
  return (
    <>
      <Navbar navLight={false} playBtn={false} bgLight={false} navCenter={false} />

      <section
        className="relative overflow-hidden pt-60 after:content-[''] after:absolute after:inset-0 after:mx-auto after:size-[56rem] after:bg-gradient-to-tl after:to-indigo-600/40  after:from-cyan-600/40 after:blur-[200px] after:rounded-full after:-z-1"
        id="home"
      >
        <div className="container relative z-2">
          <div className="grid grid-cols-1 text-center">
            <div className="">
              <h4 className="lg:leading-normal leading-normal text-4xl lg:text-[54px] mb-5">
                {t('title')}
                <br />
                <span className="typewrite font-bold inline-block">{t('app_name')}</span>
              </h4>
              <p className="text-slate-500 dark:text-white/60 text-lg max-w-xl mx-auto">
                {t('description')}
              </p>

              {/* <div className="subcribe-form mt-6 mb-3">
                <form className="relative max-w-lg mx-auto">
                  <FiMail className="size-4 absolute top-[17px] start-5 text-slate-400" />
                  <input
                    type="email"
                    id="subcribe"
                    name="email"
                    className="form-input border-0 py-4 ps-12 pe-12 w-full h-[50px] outline-none text-black dark:text-white rounded-full bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 focus:border-0 focus:ring-0"
                    placeholder="Eposta adresiniz:"
                  />
                  <button
                    type="submit"
                    className="size-[46px] inline-flex items-center justify-center rounded-full align-middle absolute top-[2px] end-[3px] bg-indigo-500 border-indigo-500 text-white"
                  >
                    <FiArrowRight className="size-5" />
                  </button>
                </form>
              </div>

              <span className="text-slate-500 dark:text-white/60 font-medium">
                Looking for help?{' '}
                <Link to="" className="text-red-500">
                  Get in touch with us
                </Link>
              </span> */}
            </div>
            <div className="relative mt-4 lg:mx-16 z-3">
              <img src={hero} alt="" className="mover" />
            </div>
          </div>
        </div>
      </section>

      <section className="relative md:py-24 py-16" id="features">
        <div className="container relative">
          <div className="grid grid-cols-1 pb-6 text-center">
            <h6 className="text-indigo-500 uppercase text-sm font-bold tracking-wider mb-3">
              {t('features_title')}
            </h6>
            <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">
              {t('features_subtitle')}
            </h4>

            <p className="text-slate-400 max-w-xl mx-auto">{t('features_description')}</p>
          </div>

          <FeaturesTwo />
        </div>

        <div className="container relative md:mt-24 mt-16">
          <AboutOne />
        </div>

        <div className="container relative md:mt-24 mt-16">
          <AboutTwo />
        </div>
      </section>

      <section
        className="relative md:py-24 py-16 bg-slate-50/50 dark:bg-slate-800/20"
        id="screenshot"
      >
        <div className="container relative">
          <div className="grid grid-cols-1 pb-6 text-center">
            <h6 className="text-indigo-500 uppercase text-sm font-bold tracking-wider mb-3">
              {t('screenshots_title')}
            </h6>
            <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">
              {t('screenshots_subtitle')}
            </h4>

            <p className="text-slate-400 max-w-xl mx-auto">{t('screenshots_description')}</p>
          </div>

          <Screenshot />
        </div>
      </section>

      <section className="relative overflow-hidden md:py-24 py-16" id="faqs">
        <Faq />
      </section>

      <section
        className="relative md:py-24 py-16 bg-slate-50/50 dark:bg-slate-800/20"
        id="download"
      >
        <Download />
      </section>

      <section className="relative md:py-24 py-16" id="reviews">
        <div className="container relative">
          <div className="grid grid-cols-1 pb-6 text-center">
            <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">
              {t('team_title')}
            </h6>
            <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">
              {t('team_subtitle')}
            </h4>

            <p className="text-slate-400 max-w-xl mx-auto">{t('team_description')}</p>
          </div>
          <Client />
        </div>
      </section>

      <section className="relative md:py-24 py-16 bg-slate-50/50 dark:bg-slate-800/20" id="contact">
        <Contact />
      </section>

      <section className="border-t border-b border-gray-100 dark:border-gray-800">
        <div className="container relative justify-content-center">
          <Partner />
        </div>
      </section>

      <Footer />
    </>
  );
}
